import moment from 'moment-timezone';
import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('product');
const GET_PRODUCTS = define('GET_PRODUCTS', true);
const GET_PRODUCT = define('GET_PRODUCT', true);
const GET_PRICE = define('GET_PRICE', true);
const LOAD_AVAILABILITY = define('LOAD_AVAILABILITY', true);
const SET_CURRENT_PAGE = define('SET_CURRENT_PAGE');
const OPEN_MODAL = define('OPEN_MODAL');
const CLOSE_MODAL = define('CLOSE_MODAL');
const BOOK_PRODUCT = define('BOOK_PRODUCT', true);

const initialState = {
  count: 0,
  currentPage: 1,
  products: [],
  isLoadingProducts: true,
  selectedProduct: null,
  isLoadingProduct: true,
  isLoadingAvailability: true,
  productAvailability: [],
  isShowBookModal: false,
  price: {},
  isLoadingPrice: true,
  isBookingProduct: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS.PENDING:
      return {
        ...state,
        isLoadingProducts: true,
        selectedProduct: null,
        currentPage: action.page
      };
    case GET_PRODUCTS.RESOLVED:
      return {
        ...state,
        isLoadingProducts: false,
        products: action.data.products,
        count: action.data.count,
      };
    case GET_PRODUCT.PENDING:
      return {
        ...state,
        isLoadingProduct: true,
      };
    case GET_PRODUCT.RESOLVED:
      return {
        ...state,
        isLoadingProduct: false,
        selectedProduct: action.data
      };
    case GET_PRICE.PENDING:
      return {
        ...state,
        isLoadingPrice: true
      };
    case GET_PRICE.RESOLVED:
      return {
        ...state,
        isLoadingPrice: false,
        price: action.data
      };
    case LOAD_AVAILABILITY.PENDING:
      return {
        ...state,
        isLoadingAvailability: true
      };
    case LOAD_AVAILABILITY.RESOLVED:
      return {
        ...state,
        isLoadingAvailability: false,
        productAvailability: action.data
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.page
      };
    case OPEN_MODAL:
      return {
        ...state,
        isShowBookModal: true,
        selectedProduct: {
          name: action.name
        }
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isShowBookModal: false
      };
    case BOOK_PRODUCT.PENDING:
      return {
        ...state,
        isBookingProduct: true,
      };
    case BOOK_PRODUCT.RESOLVED:
    case BOOK_PRODUCT.REJECTED:
      return {
        ...state,
        isBookingProduct: false,
      };
    default: return state;
  }
};

export const actions = {
  getProducts: (skip = 0, query = {}) => {
    const qs = [];
    if (query.name && query.name.trim().length > 0) {
      qs.push(`name=${query.name}`);
    }
    if (query.city && query.city !== 'all') {
      qs.push(`city=${query.city}`);
    }
    if (query.productType && query.productType !== 'all') {
      qs.push(`product_type=${query.productType}`);
    }
    return {
      type: GET_PRODUCTS,
      promise: api.get(`/partner/products?skip=${skip}&limit=12${qs.length > 0 ? `&${qs.join('&')}` : ''}`),
      page: (skip / 12) + 1
    };
  },
  getProduct: slug => ({
    type: GET_PRODUCT,
    promise: api.get(`/partner/products/${slug}`)
  }),
  getPrice: (body) => ({
    type: GET_PRICE,
    promise: api.post('/partner/products/price', body)
  }),
  loadAvailability: (tripId, monthYear = moment().format('MMMM YYYY')) => ({
    type: LOAD_AVAILABILITY,
    promise: api.get(`/partner/calendar?trip_id=${tripId}&month=${monthYear}`),
    error: 'Failed to load availability'
  }),
  setCurrentPage: (page) => ({
    type: SET_CURRENT_PAGE,
    page
  }),
  openModal: (name) => ({
    type: OPEN_MODAL,
    name
  }),
  closeModal: () => ({
    type: CLOSE_MODAL
  }),
  bookProduct: data => ({
    type: BOOK_PRODUCT,
    promise: api.post('/partner/transactions/book', data),
  })
};



// WEBPACK FOOTER //
// ./src/modules/product.js